<template>
	<div data-component="general-deal-list-item">
		<component
			:is="getComponent"
			v-bind="getProps"
		>
			<template #actions="{ deal }">
				<btn
					v-if="isAdded(deal)"
					@click.native="removeDealFromSelection(deal)"
					text="Remove"
					colour="red"
					size="sm"
				/>
				<btn
					v-else
					@click.native="addDealToSelection(deal)"
					text="Add"
					size="sm"
				/>
			</template>
			<template #groupActions="{ group }">
				<span
					v-if="addedInGroupCount(group) > 0"
					data-element="added-count"
				>
					{{ addedInGroupCount(group) }}
				</span>
			</template>
		</component>
		<slot name="actions" />
	</div>
</template>

<script>

	import Deal   from '@/components/dealLibrary/Deal';
	import Group  from '@/components/dealLibrary/Group';
	import Btn from '@/components/ui/Btn';

	export default {
		components: {
			Deal,
			Group,
			Btn
		},
		props: {
			group: {
				type: Object,
				required: true
			},
			deals: {
				type: Array,
				default: undefined
			}
		},
		data: () => ({}),
		computed: {
			getComponent () {
				if (this.group?.deals?.length > 1) {
					return 'Group';
				}
				return 'Deal';
			},
			getProps () {
				if (this.getComponent === 'Deal') {
					return {
						deal: this.group.deals[0]
					};
				}
				return {
					group: this.group
				};
			},
			getDeals () {
				return this.deals || [];
			}
		},
		methods: {
			isAdded (deal) {
				return this.getDeals.some(item => item.id === deal.id);
			},
			addedInGroupCount (group) {
				return this.getDeals
					.filter(deal => group.deals
						.some(item => item.id === deal.id)
					).length;
			},
			addDealToSelection (deal) {
				this.$emit('addDealToSelection', deal);
			},
			removeDealFromSelection (deal) {
				this.$emit('removeDealFromSelection', deal);
			}
		}
	};

</script>

<style lang="scss" scoped>

	[data-component='general-deal-list-item'] {
		[data-element='added-count'] {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			width: rem(22);
			height: rem(22);
			font-size: rem(14);
			line-height: 1;
			font-weight: 700;
			text-align: center;
			color: $c-white;
			background-color: $c-brand-red-lighter-1;
			border-radius: 50%;
		}
	}

</style>
